import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const TableBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  border: solid 1px ${(p) => p.theme.colors.border2};
  background-color: ${(p) => p.theme.colors.background};
  width: 100%;
`;

export const TableText = styled(Typography)`
  font-size: ${(p) => p.theme.text.fontSizes.m};
  display: flex;
  gap: 0.25rem;
  align-items: center;
  min-height: 24px;

  svg {
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }
`;
